export var TokenType;
(function (TokenType) {
    TokenType["Ibc"] = "ibc";
    TokenType["Cw20"] = "cw20";
    TokenType["Spl"] = "spl";
    TokenType["Erc20"] = "erc20";
    TokenType["Native"] = "native";
    TokenType["TokenFactory"] = "tokenFactory";
    TokenType["InsuranceFund"] = "insuranceFund";
    TokenType["Unknown"] = "unknown";
})(TokenType || (TokenType = {}));
export var Cw20TokenSource;
(function (Cw20TokenSource) {
    Cw20TokenSource["Solana"] = "solana";
    Cw20TokenSource["Cosmos"] = "cosmos";
    Cw20TokenSource["Ethereum"] = "ethereum";
    Cw20TokenSource["EthereumWh"] = "ethereum-wormhole";
})(Cw20TokenSource || (Cw20TokenSource = {}));
//# sourceMappingURL=types.js.map